import { useState } from "react";
import { useTranslation } from "react-i18next";
import { setRegionKeySource } from "@certn/utils";

import { DropdownMenu } from "../../dropdown-menu/DropdownMenu";
import { MenuItem } from "../../dropdown-menu/assets/MenuItem";
import { MenuSection } from "../../dropdown-menu/assets/MenuSection";

type RegionKey = "ca" | "uk" | "au";

export function TopNavRegionToggle() {
  const { t } = useTranslation();

  const regions: Record<RegionKey, { label: string; shortLabel: string }> = {
    ca: {
      label: t("North America"),
      shortLabel: t("N. America"),
    },
    uk: {
      label: t("Europe, Middle East and Africa"),
      shortLabel: t("EMEA"),
    },
    au: {
      label: t("Asia Pacific"),
      shortLabel: t("Asia Pacific"),
    },
  };

  const [regionKey, setRegionKey] = useState<RegionKey>(() => {
    const regionKey = localStorage.getItem("region-key") ?? "";

    if (regionKey in regions) return regionKey as RegionKey;

    return "ca";
  });

  const handleChange = (key: RegionKey) => {
    if (key !== regionKey) {
      setRegionKey(key);
      localStorage.setItem("region-key", key);
      setRegionKeySource("explicit");

      // replace region key in the url
      const pathItems = window.location.pathname.split("/");
      pathItems[1] = key;
      window.location.pathname = pathItems.join("/");
    }
  };

  return (
    <DropdownMenu
      label={regions[regionKey].shortLabel}
      onItemAction={handleChange}
      minWidth="256px"
    >
      <MenuSection title={t("SELECT REGION")}>
        {Object.entries(regions).map(([key, { label }]) => (
          <MenuItem
            icon={
              key === regionKey
                ? "radio_button_checked"
                : "radio_button_unchecked"
            }
            iconPosition="right"
            id={key}
            key={key}
            testID="select-region-menu-item"
          >
            {label}
          </MenuItem>
        ))}
      </MenuSection>
    </DropdownMenu>
  );
}
